import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faComment } from '@fortawesome/pro-solid-svg-icons';
import { Note } from '@aptitude/shared-vanilla';

import { variables } from '../../variables';
import '../../icons/icon/apt-icon';


@customElement('apt-notes-list')
export class NotesList extends LitElement {
  @property({ type: Array })
  notes = [] as Array<Note>;

  iconData = {
    type: faComment,
    text: { inner: '', outer: '', },
    class: 'fas fa-comment'
  };

  iconProperties = {
    width: '18px',
    height: '18px',
    padding: '0',
    iconSize: '16px',
    textSize: '14px',
    iconTextBottom: '14px',
    color: 'gray-600',
    bgColor: 'transparent',
    hoverColor: 'gray-600',
    hoverBgColor: 'transparent',
    disabledColor: 'transparent',
    disabledBgColor: 'transparent',
  };

  static override get styles() {
    return [
      variables,
      css`
        :host  {
          font-size: 14px;
        }

        ul{
          list-style-type: none;
          overflow-y: auto;
          overflow-x: hidden;
            padding-inline-start: 5px;
        }

        li {
          border-bottom: 1px solid var(--gray-400);
          padding: 10px 0;
          color: var(--black);
        }

        li:last-of-type {
          border-bottom: none;
          padding: 10px 0 0;
        }

        .ellipsis{
          text-overflow: ellipsis;
        }

        .note {
          position:relative;
          display: flex;
          justify-content: flex-start;
          margin-bottom: 4px;
          color: var(--gray-600);
        }
        
        .note .date,
        .note .email {
          position: absolute;
          margin-left: 20px;
        }
        
        .note .email {
          max-width: 220px;
        }

        .animate .date {
          transition: all linear 0.5s;
          opacity: 1;
        }

        .animate .email {
          transition: all linear 0.5s;
          opacity: 0;
        }

        .animate:hover .date {
          transition: all linear 0.5s;
          opacity: 0;
        }

        .animate:hover .email {
          transition: all linear 0.5s;
          opacity: 1;
        }
      `,
    ];
  }

  override render() {
    return html`
      <ul class="notes">
        ${this.notes.map(
      (note: Note) => html`
            <li class="animate">
              <div class="note">
                <span>
                  <apt-icon 
                    .data="${this.iconData}"
                    .properties="${this.iconProperties}"
                    ?disabled="${false}">
                    <span></span>
                  </apt-icon>
                </span>
                <span class="date">${note.auditInfo.createdDate}</span>
                <span class="email ellipsis"> ${note.auditInfo.createdBy}</span>
              </div>
              <div class="text">${note.note}</div>
            </li>
        `)}
      </ul>
    `;
  }

  protected override firstUpdated(): void {

    library.add(faComment);

    // @ts-expect-error The dom.watch() TS definition indicates no parameters for this. However, when
    // you actually dig into the code, you see that it looks at the arguments after it gets into
    // the code and tries to pull some out if there aren't any (it even supplies an empty object
    // for options if you don't supply one yourself).
    //
    // Note: We have to wait for the first update for the shadow DOM to even be created.
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'apt-notes-list': NotesList;
  }
}
